import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'

export default {
  name: 'ContentsNoticeSound',
  components: {
    FileSelectorButton
  },
  data () {
    return {
      input: {
        noticeSoundJingleUseFlg: 0,
        noticeSoundjingleFile: null,
        noticeSoundvoiceMessageUseFlg: 0,
        noticeSoundvoiceMessageFile: null,
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsSetting.categoryName,

      // form
      serviceId: state => state.serviceContentsSettingForm.serviceId,
      serviceContentsId: state => state.serviceContentsSettingForm.targetId,
      values: state => state.serviceContentsSettingForm.values,
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
      isRegister: 'serviceContentsSettingForm/isRegister',
      isModify: 'serviceContentsSettingForm/isModify',
    }),

    // list
    noticeSoundJingleUseList () {
      return Constants.ServiceContents.NoticeJingleUse.sort(Utility.sortByKey('index', true))
    },
    noticeVoiceMessageUseList () {
      return Constants.ServiceContents.NoticeVoiceMessageUse.sort(Utility.sortByKey('index', true))
    },

    // validate
    formIsValid () {
      const v1 = this.validate('noticeSoundJingleUseFlg') &&
        this.validate('noticeSoundvoiceMessageUseFlg')
      if (!v1) return false

      // ジングル音利用
      let v2 = false
      if (this.input.noticeSoundJingleUseFlg === 1) {
        v2 = this.validate('noticeSoundjingleFile')
      } else {
        v2 = true
      }
      if (!v2) return false

      // 音声メッセージ利用
      let v3 = false
      if (this.input.noticeSoundvoiceMessageUseFlg === 1) {
        v3 = this.validate('noticeSoundvoiceMessageFile')
      } else {
        v3 = true
      }
      if (!v3) return false

      return true
    },

    // jsonb
    getJsonb () {
      let jsonb = {
        noticeSoundJingleUseFlg: this.input.noticeSoundJingleUseFlg,
        noticeSoundvoiceMessageUseFlg: this.input.noticeSoundvoiceMessageUseFlg,
      }

      // ジングル音
      if (jsonb.noticeSoundJingleUseFlg === 1) {
        jsonb.noticeSoundjingleFile = this.input.noticeSoundjingleFile
      }

      // 音声メッセージ
      if (jsonb.noticeSoundvoiceMessageUseFlg === 1) {
        jsonb.noticeSoundvoiceMessageFile = this.input.noticeSoundvoiceMessageFile
      }
      
      return jsonb
    },
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate({
          key: 'contentsNoticeSound',
          value: this.formIsValid
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({

    }),
    ...mapMutations({
      setValidate: 'serviceContentsSettingForm/setValidate'
    }),

    init () {
      if (this.values.contentsNoticeSound) {
        let data = $.extend(true, this.input, this.values.contentsNoticeSound)
        this.$set(this, 'input', data)
      }

      this.setValidate({
        key: 'contentsNoticeSound',
        value: this.formIsValid
      })
    },

    /**
     * ファイル
     */
    getInputNode (name) {
      let nodes = name.split('.')
      let origin = this.input
      let key
      nodes.forEach((item, index) => {
        if (index < nodes.length - 1) {
          origin = origin[item]
        } else {
          key = item
        }
      })
      return {
        parent: origin,
        key: key
      }
    },
    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, Jsonb.formatFile(props.data))
      console.log('changeFileFromSelector', data.parent[data.key])
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, null)
      console.log('deleteFileFromSelector', null)
    },

    validate (key) {
      switch (key) {
        case 'noticeSoundJingleUseFlg':
        case 'noticeSoundvoiceMessageUseFlg':
          return Validator.validRadio(this.input[key])
        case 'noticeSoundjingleFile':
        case 'noticeSoundvoiceMessageFile':
          return Validator.validFile(this.input[key])
      }
    },
  }
}
